import React, { useMemo } from "react";

import ListGroup from "./ListGroup";
import { LabelMode } from "../ui_atoms/Label";
import { getActivityNavigationInfo } from "../hooks/activities";
import { IconName } from "./Icon";
import { SHORT_DATE_IN_LIST_FORMAT_OPTIONS, useDateFormatter } from "../hooks/date";

export enum ActivityType {
    todo = "todo",
    log = "log",
}

export type Activity = {
    id: string;
    name: string;
    activityKey?: string | null;
    createdAt: string;
    title: string;
    text: string;
    badgeUrl?: string | null;
    actionText?: string | null;
    at: Date;
    priority: number;
    type: ActivityType;
    isActive?: boolean;
    sourceName?: string | null;
};

type ActivityListViewProps = {
    activities: Activity[];
    onSelectActivity?: (activity: Activity) => void | Promise<void>;
    disabled?: boolean;
    shadowActivityId?: string;
};
// eslint-disable-next-line @typescript-eslint/no-var-requires
const basquiatAvatarUrl = require("../assets/images/basquiat-avatar.png");

export const ActivityListView: React.FC<ActivityListViewProps> = ({
    activities,
    onSelectActivity,
    disabled = false,
    shadowActivityId,
}) => {
    const intDateFormatter = useDateFormatter();

    const items = useMemo(() => {
        return activities.map((activity) => ({
            title: activity.title,
            description: activity.text,
            value: activity.id,
            unread: activity.isActive,
            labels: [{ text: activity.actionText || undefined, mode: "cta" as LabelMode }],
            tags: activity.sourceName
                ? [
                      intDateFormatter(activity.at, SHORT_DATE_IN_LIST_FORMAT_OPTIONS),
                      activity.sourceName,
                  ]
                : [intDateFormatter(activity.at, SHORT_DATE_IN_LIST_FORMAT_OPTIONS)],
            avatarPath: activity.badgeUrl || basquiatAvatarUrl,
            useBigAvatarOrIcon: true,
            onPress: disabled
                ? undefined
                : () => {
                      void onSelectActivity?.(activity);
                  },
            isShaded: shadowActivityId === activity.id,
            rightIcon: getActivityNavigationInfo(activity.name, activity.activityKey)
                ? "chevron-right"
                : ("__empty__" as IconName),
        }));
    }, [activities, intDateFormatter, disabled, shadowActivityId, onSelectActivity]);
    return <ListGroup isItemsCheckable={false} items={items} alignment="stretch" />;
};

export default ActivityListView;
